module.exports = "/images/question.svg?0148b81571667eac2ab1c79196499ca8";